export const PERMISSIONS = {
  // 用戶
  'users.read': '查看用戶',
  'users.write': '編輯用戶',
  'users.suspend': '停用用戶',
  // 內容
  'content.read': '查看內容',
  'content.delete': '刪除內容',
  // 客服
  'tickets.read': '查看工單',
  'tickets.write': '回覆工單',
  // 郵件
  'email.read': '查看郵件',
  'email.write': '建立郵件',
  'email.send': '發送郵件',
  // 銷售
  'sales.read': '查看銷售',
  'promo.read': '查看折扣碼',
  'promo.write': '管理折扣碼',
  // 財務
  'finance.read': '查看財務',
  'finance.refund': '處理退款',
  // 系統
  'admin.read': '查看管理員',
  'admin.write': '管理管理員',
} as const;

export type Permission = keyof typeof PERMISSIONS;

export function hasPermission(
  userPermissions: string[] | undefined | null,
  required: Permission | Permission[]
): boolean {
  if (!userPermissions) return false;
  
  // super_admin 有 "*" 權限
  if (userPermissions.includes('*')) return true;
  
  const requiredList = Array.isArray(required) ? required : [required];
  return requiredList.every(p => userPermissions.includes(p));
}
